import React from 'react';

const Section = ({ title, children }) => (
    <div className="mb-8">
        <h2 className="text-sm font-bold mb-3" style={{ color: 'var(--text)', fontFamily: "var(--font-display)" }}>{title}</h2>
        <div className="text-xs leading-relaxed space-y-2" style={{ color: 'var(--muted)' }}>{children}</div>
    </div>
);

export default function TermosPage() {
    return (
        <div className="min-h-screen" style={{ background: 'var(--bg)' }}>
            <div className="max-w-3xl mx-auto px-4 py-12 md:py-20">
                <h1 className="text-4xl sm:text-5xl font-bold mb-2" style={{ color: 'var(--text)', fontFamily: "var(--font-display)" }}>
                    Termos de <span style={{ color: 'var(--gold-2)' }}>Uso</span>
                </h1>
                <p className="text-xs mb-10" style={{ color: 'var(--muted)' }}>Última atualização: Março de 2026</p>

                <div className="rounded-xl p-6 md:p-8" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }} data-testid="terms-content">
                    <Section title="1. Aceitação dos Termos">
                        <p>Ao acessar e utilizar a plataforma SuperVitrine, você concorda com estes Termos de Uso. Caso não concorde, por favor, não utilize nossos serviços.</p>
                    </Section>

                    <Section title="2. Descrição do Serviço">
                        <p>A SuperVitrine é uma plataforma de curadoria e divulgação de ofertas e promoções disponíveis na internet. Não somos responsáveis pela venda direta de produtos ou serviços anunciados.</p>
                    </Section>

                    <Section title="3. Cadastro e Conta">
                        <p>Para acessar funcionalidades avançadas, é necessário criar uma conta. Você é responsável por manter a confidencialidade das suas credenciais e por todas as atividades realizadas na sua conta.</p>
                    </Section>

                    <Section title="4. Uso Aceitável">
                        <p>Você concorda em utilizar a plataforma de forma ética e legal. É proibido publicar conteúdo falso, enganoso, ofensivo, ou que viole direitos de terceiros.</p>
                    </Section>

                    <Section title="5. Propriedade Intelectual">
                        <p>Todo o conteúdo, design e funcionalidades da SuperVitrine são protegidos por direitos autorais. A reprodução não autorizada é proibida.</p>
                    </Section>

                    <Section title="6. Planos e Pagamentos">
                        <p>Alguns recursos são oferecidos em planos pagos. Os valores e condições são apresentados na página de planos. Pagamentos são processados por meio de provedores seguros.</p>
                    </Section>

                    <Section title="7. Limitação de Responsabilidade">
                        <p>A SuperVitrine não garante a disponibilidade, preço ou qualidade dos produtos anunciados por terceiros. Nosso papel é informativo e de curadoria.</p>
                    </Section>

                    <Section title="8. Modificações">
                        <p>Reservamo-nos o direito de modificar estes termos a qualquer momento. Alterações significativas serão comunicadas por e-mail ou notificação na plataforma.</p>
                    </Section>

                    <Section title="9. Contato">
                        <p>Para questões sobre estes termos, entre em contato: <a href="mailto:contato@supervitrineofertas.com" className="underline" style={{ color: 'var(--gold-2)' }}>contato@supervitrineofertas.com</a></p>
                    </Section>
                </div>
            </div>
        </div>
    );
}
